export const AEREPORTS = {
    ID: "3cc36c54-fc79-400d-8bea-b2146cb95a80",
    EVENT_REPORT_LIST: "315b5e8f-5bff-48f8-a81a-dd71e1fda726"
}

